import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Bugsnag from '@bugsnag/js';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
export const DevToolsMiscPage = () => {
    const onClickLoseWebGlContext = useCallback(() => {
        const canvas = document.createElement('canvas');
        canvas.addEventListener('webglcontextlost', (event) => {
            event.preventDefault();
            console.error('WebGL context was lost and handler is called');
            Bugsnag.notify(new Error('WebGL context loss test'));
        }, false);
        const ctx = canvas.getContext('webgl');
        if (!ctx) {
            console.error('Could not get initial WebGL context');
            return;
        }
        const loseContextExtension = ctx.getExtension('WEBGL_lose_context');
        if (!loseContextExtension) {
            console.error('WEBGL_lose_context extension is not supported');
            return;
        }
        // force context to be lost:
        loseContextExtension.loseContext();
    }, []);
    return (_jsx(Button, { onClick: onClickLoseWebGlContext, variant: 'contained', children: "Test WebGL Context Loss" }));
};
